import { api } from "../api";
import { store } from "../store";
import { store as uiStore } from "../store/ui";
import { DOWNLOAD_STATUS } from "../HelperSrc";
import { DownloadFile } from "../interface";
import { lang } from "../lang";
import * as HelperSrc from "../HelperSrc";

async function getDownloadList(workbook: string, only_new = false, tables: string | null = null): Promise<void> {
    uiStore.setDownloadStatus(DOWNLOAD_STATUS.PROCESSING);
    let hasResults = false;

    if (api.workbookApi) {
        await api.workbookApi.getDownloadList(store.db ? store.db : "", workbook, only_new, tables).then((response) => {
            if (response instanceof Error || (response.message && response.message.error)) {
                if (response instanceof Error) {
                    HelperSrc.writeLog("error", response);
                } else {
                    store.doNotice(lang[response.message.error]);
                }
            } else {
                const responseData = response as unknown as { results?: DownloadFile[] };

                if (responseData.results) {
                    uiStore.setDownloadingWB(workbook);
                    uiStore.setIsShowDownload(true);
                    store.setWaitingDownload(responseData.results);
                    hasResults = true;

                    return;
                }
            }
        });
    }

    if (hasResults) {
        return;
    }

    uiStore.setDownloadStatus(DOWNLOAD_STATUS.DOWNLOADED);
}

export { getDownloadList };
